module.exports = __webpack_public_path__ + "img/white-round-check.b6d13540.svg";